var l = 10;
var lMin = 5;
var lMax = 15;

var h = 7;
var hMin = 5;
var hMax = 10;

var w = 6;
var wMin = 3;
var wMax = 12;

var sw = 3;
var swMin = 2;
var swMax = 6;

var sl = 8;
var slMin = 7.5;
var slMax = 10;

var ss = 6;
var ssMin = 3;
var ssMax = 15;


var minWeight = 5.046875;
var maxWeight = 31.875;


var frontPlate;
var backPlate;
var bottomPlate;
var strap1;
var strap2;


// ##################################
//	HOOKS
// ##################################
function initRangeSliders(){
  lRange = initRangeSlider("lRange", changeLength, lMin, l, lMax);
  hRange = initRangeSlider("hRange", changeHeight, hMin, h, hMax);
  wRange = initRangeSlider("wRange", changeWidth, wMin, w, wMax);
  swRange = initRangeSlider("swRange", changeStrapWidth, swMin, sw, swMax);
  slRange = initRangeSlider("slRange", changeStrapLength, slMin, sl, slMax);
  ssRange = initRangeSlider("ssRange", changeStrapSpacing, ssMin, ss, ssMax);
}

function createConnector(){
  addSidePlates();
  addBottomPlate();
  addStraps();
}

function getConnectorProperties(){
  return {
    'Saddle length': l,
    'Saddle height': h,
    'Saddle width': w,
    'Strap width': sw,
    'Strap length': sl,
    'Strap spacing': ss,
  };
}

function updateConnectorPrice(){
  var squareInches = (2*l*h)+(w*l)+(2*sw*sl);
  updatePrice(squareInches);
}


// ##################################
//	PRIVATE
// ##################################
function addSidePlates(){
  frontPlate = addSidePlate(frontPlate, -l/2, 0, w/2);
  backPlate = addSidePlate(backPlate, -l/2, 0, -(w/2+plateThickness));
}

function addSidePlate(sidePlate, x, y, z){
  var plate = replaceShapeFromPoints(sidePlate, [[l, h]]);
  addHole(plate, l-holeOffset, h-holeOffset);
  addHole(plate, holeOffset, h-holeOffset);
  addBottomHole(plate, h, holeOffset);
  addBottomHole(plate, h, l-holeOffset);
  var geometry = extrude(plate);
  return addMeshAt(geometry, x, y, z);
}

function addBottomPlate(){
  var plate = replaceShapeFromPoints(bottomPlate, [[l, w]]);
  var geometry = extrude(plate, Math.PI/2);
  bottomPlate = addMeshAt(geometry, -l/2, 0, -w/2);
}

function addStraps(){
  strap1 = addStrap(strap1, -ss/2, -(sl + plateThickness), -sw/2);
  strap2 = addStrap(strap2, ss/2, -(sl + plateThickness), -sw/2);
}

function addStrap(strap, x, y, z){
  var plate = replaceShapeFromPoints(strap, [[sl, sw]]);
  addHole(plate, holeOffset, sw/2);
  addHole(plate, holeOffset+strapHoleSpace, sw/2);
  var geometry = extrude(plate, undefined, Math.PI/2, Math.PI/2);
  return addMeshAt(geometry, x, y, z);
}

function changeLength(){
  if(lRange.value < ss){
    lRange.value = ss;
    showHint('Decrease strap spacing to shorten further');
  }
  else{
    l = Number(lRange.value);
    addSidePlates();
    addBottomPlate();
    updateConnectorPrice();
  }
}

function changeHeight(){
  h = Number(hRange.value);
  addSidePlates();
  addBottomPlate();
  updateConnectorPrice();
}

function changeWidth(){
  if(wRange.value < sw) {
    wRange.value = sw;
    showHint('Decrease strap width to narrow further');
  }
  else {
    w = Number(wRange.value);
    addSidePlates();
    addBottomPlate();
    updateConnectorPrice();
  }
}

function changeStrapWidth(){
  if(swRange.value > w){
    swRange.value = w;
    showHint('Increase saddle width to widen further');
  }
  else {
    sw = Number(swRange.value);
    addStraps();
    updateConnectorPrice();
  }
}

function changeStrapLength(){
  sl = Number(slRange.value);
  addStraps();
  updateConnectorPrice();
}

function changeStrapSpacing(){
  if(ssRange.value > l){
    ssRange.value = l;
    showHint('Increase saddle length to widen further');
  }
  else{
    ss = Number(ssRange.value);
    addStraps();
  }
}
 
